import { ICON_DEFAULT_STYLE } from "@/shared";
import Typography from "@mui/material/Typography";

import { CheckCircleIcon, colors } from "@dotnet/telematics-design-system";

interface IValidationRuleItemProps {
  isRuleMet: boolean;
  ruleText: string;
}

const ValidationRuleItem = ({
  isRuleMet,
  ruleText
}: IValidationRuleItemProps) => {
  const { green600, textDark, textDisabled } = colors;

  return (
    <div>
      <CheckCircleIcon
        data-testid="CheckCircleIcon"
        style={{
          ...ICON_DEFAULT_STYLE,
          color: isRuleMet ? green600 : textDisabled
        }}
      />
      <Typography
        variant="body2Medium"
        sx={{ color: textDark, marginLeft: "8px" }}
      >
        {ruleText}
      </Typography>
    </div>
  );
};

export default ValidationRuleItem;
